import { FormatType } from '../../types';
import { getFormatter } from '../../utilities';
import styles from './volume-tooltip.module.css';

export type VolumeSeriesLabels = {
  active: string;
  new: string;
  removed: string;
};

export const DEFAULT_VOLUME_LABELS: VolumeSeriesLabels = {
  active: 'Active postings',
  new: 'New postings',
  removed: 'Removed postings',
};

export interface VolumeTooltipProps {
  title: string;
  active: number;
  newPostings: number;
  removed: number;
  format?: FormatType;
  labels?: VolumeSeriesLabels;
  showActive?: boolean;
}

export const VolumeTooltip = ({
  title,
  active,
  newPostings,
  removed,
  format = FormatType.INTEGER,
  labels = DEFAULT_VOLUME_LABELS,
  showActive = true,
}: VolumeTooltipProps) => {
  const formatValue = getFormatter(format);

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.rows}>
        {showActive && (
          <div className={styles.row}>
            <span>{labels.active}</span>
            <span>{formatValue(active)}</span>
          </div>
        )}
        {newPostings > 0 && (
          <div className={styles.row}>
            <span>{labels.new}</span>
            <span>{formatValue(newPostings)}</span>
          </div>
        )}
        {removed > 0 && (
          <div className={styles.row}>
            <span>{labels.removed}</span>
            <span>{formatValue(removed)}</span>
          </div>
        )}
      </div>
    </div>
  );
};
